<div class="landing-page-v4 landingpage-background breadcrumb-container">
    <ng-container *ngFor="let section of sectionOrder">
        <ng-container [ngSwitch]="section.component">

            <ng-container *ngSwitchCase="'carousel'">
                <div class="page-banner landingpage-banner-height"
                    *ngIf="!isCarouselContentAvailable && !carouselLoader">
                    <app-landing-page-body [dynamicContentData]="dynamicContentData"></app-landing-page-body>
                </div>
                <div class="page-carousel mb-3" *ngIf="!carouselLoader && isCarouselContentAvailable">
                    <app-carousel [carouselConfig]="carouselConfig" (mediaReady)="onCarouselReady()"></app-carousel>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="'video'">

                <div class="home-video-library mb-3 ps-0 pe-3 col-lg-12" *ngIf="allVideos?.length > 0">
                    <app-home-library [allVideos]="allVideos" [isHomePage]="landing" (mediaReady)="onVideoLibraryReady()"></app-home-library>
                </div>
            </ng-container>

            <ng-container *ngSwitchCase="'service'">
                <div class="d-flex sv-vl-height">
                    <div class="page-services col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <app-landing-page-services
                            [dynamicContentData]="dynamicContentData"></app-landing-page-services>
                    </div>
                </div>
            </ng-container>


            <!-- Dynamic HTML content -->
            <ng-container *ngSwitchDefault>
                <div class="row m-0 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div [innerHTML]="section.htmlContent"></div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>